import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Navbar } from '@/components/generals/navbar'
import { Footer } from '@/components/generals/footer'
import { QuickExit } from '@/components/generals/quick-exit'

export const Layout: FC<LayoutProps> = ({ children, tone = 'page' }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a className='skip-link' href='#conteudo'>
                Pular para o conteúdo
            </a>

            <Navbar />

            <main id='conteudo' className='flex-1' tabIndex={-1}>
                {children}
            </main>

            {tone === 'page' && <Footer />}

            <QuickExit />
        </div>
    )
}
